import { render, staticRenderFns } from "./JsLogo.vue?vue&type=template&id=016839af&"
import script from "./JsLogo.vue?vue&type=script&lang=js&"
export * from "./JsLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports